import { render } from "./department-list.vue?vue&type=template&id=7fca764c"
import script from "./department-list.vue?vue&type=script&lang=js"
export * from "./department-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__